// Datos personales, redes y contacto. Edita este archivo para actualizar el perfil

import { ChatChannel, ProfileElement, ResumeExternalSource, ResumeFile, SocialLinkItem } from 'types';
import { getPublicPath } from './environment';

const publicPath = getPublicPath();

export const profilePhoto = `${publicPath}/assets/img/photo/foto.png`;

export const identity = {
    firstName: 'Armando Josue',
    lastName: 'Velasquez Delgado',
    role: 'IT Engineer',
    summary: 'Full Stack developer with experience in back-end and front-end applications, turning complex challenges into practical solutions.',
};

// Archivos de currículum subidos al proyecto
export const resumeFiles: ResumeFile[] = [
    { label: 'Spanish PDF', path: `${publicPath}/assets/docs/curriculum - Armando Velasquez.pdf` },
    { label: 'English PDF', path: `${publicPath}/assets/docs/Resume - Armando Velasquez.pdf` },
];

// CV de Encuentra Empleo. El portal pide login; el PDF vive en public/assets/docs/curriculum.
export const encuentraEmpleoResume: ResumeExternalSource = {
    label: 'Encuentra Empleo',
    portalUrl: 'https://encuentraempleo.trabajo.gob.ec/socioEmpleo-war/paginas/aspirante/inicioAspirante.jsf',
    path: `${publicPath}/assets/docs/curriculum/${encodeURIComponent('Encuentra Empleo.pdf')}`,
    photo: profilePhoto,
    image: `${publicPath}/assets/icons/encuentra-empleo.ico`,
    url: '',
};

// Información del sidebar
export const profileElements: ProfileElement[] = [
    { icon: 'fa-folder-user', label: 'Resume', name: 'Download CV', action: 'download-resume' },
    { icon: 'fa-envelope', label: 'Email', name: 'josue27.velasquez9@gmail.com', url: 'mailto:josue27.velasquez9@gmail.com?subject=Contacto&body=Hi%Josue!%20I%20would%20like%20to%20contact%20you.' },
    { icon: 'fa-circle-phone', label: 'Phone', name: '+593 96 318 8745', url: 'tel:+5939167849' },
    { icon: 'fa-language', label: 'Languages', name: 'Spanish / English B1' },
    { icon: 'fa-calendar-days', label: 'Birthday', name: '27 September 2000' },
    { icon: 'fa-location-crosshairs', label: 'Location', name: 'Santo Domingo, Ecuador' },
];

// Redes sociales del sidebar
export const socialLinks: SocialLinkItem[] = [
    { name: 'LinkedIn', url: 'https://www.linkedin.com/in/armando-josue-velasquez-delgado-354399178/', icon: 'fa-linkedin' },
    { name: 'GitHub', url: 'https://github.com/Armando-Velasquez', icon: 'fa-github' },
    // { name: 'Facebook', url: 'https://www.facebook.com/people/A-Josue-Velasquez/pfbid0ABWRpfkopsXfQ7jx8wjyvQLk3SUC7G2yrSaGkjwVVVgxh5j3iKC7JuYeJaa1j9XYl/', icon: 'fa-facebook-f' },
    // { name: 'Instagram', url: 'https://www.instagram.com/josue.velasquez_ad?igsh=emdydzIxeXhjbnJl', icon: 'fa-instagram' },
];

// Enlaces de chat de la página Contact
export const chatChannels: ChatChannel[] = [
    { url: 'https://wa.me/+593963188745', icon: 'fa-whatsapp', label: 'Send Message to WhatssApp' },
    { url: 'https://m.me/100059462091385', icon: 'fa-facebook-messenger', label: 'Send Message to Messenger' },
];

// Mapa embebido de la página Contact
export const contactMapUrl =
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d149914.9943758069!2d-79.25615296153846!3d-0.23673509024049227!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x91d546535730a17d%3A0xcef17541041b9f63!2sSanto%20Domingo!5e0!3m2!1ses!2sec!4v1727993192527!5m2!1ses!2sec';
